"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockHostService = void 0;
class MockHostService {
  constructor() {
    this.getMarketingId = jest.fn();
    this.addToCart = jest.fn();
    this.redirect = jest.fn();
  }
}
exports.MockHostService = MockHostService;